"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AddDepartmentModal extends _react.Component {
  state = {
    status_messages: {},
    warning: undefined
  };
  handleChange = _ref => {
    let {
      e,
      value,
      name
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const department_to_add = state['sector[department]'];
    if (props.department) {
      if (props.department.some(function (department) {
        return department === department_to_add;
      })) {
        component.setState({
          warning: 'Département déjà ajouté'
        });
        return;
      }
    }
    props.department.push(department_to_add);
    component.setState({
      'sector[department]': undefined,
      warning: undefined
    });
    props.onClose();
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'sector[department]': undefined,
      warning: undefined
    });
    if (props.onClose) props.onClose();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const action_button = /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      className: "c-flat-btn",
      color: "primary"
    }, "Valider");
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Ajout d'un d\xE9partement",
      "scroll-area": ".back-page",
      bemit: ['small', 'simple', 'allow-overflow'],
      "close-label": "Annuler",
      "action-buttons": action_button,
      src: props.trigger_src,
      "close-classes": "c-flat-btn c-flat-btn--red u-margin-right-10"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['sector[department]'],
      name: "sector[department]",
      type: "text",
      label: "Num\xE9ro de d\xE9partement",
      status: state.status_messages
    }), status);
    return output;
  }
}
var _default = exports.default = AddDepartmentModal;
